import React, { useState, useEffect } from "react";

// utils
import { getDateString } from "../../../../utils";


const FollowUpRemarksHistory = (props) => {
    const { selectedSellerPOItem } = props

    const [followUpDateAndRemarks, setFollowUpDateAndRemarks] = useState([])

    useEffect(() => {
        const maxLength = Math.max(selectedSellerPOItem.followUpRemarksTS?.length, selectedSellerPOItem.followUpRemarks?.length)

        const followUpDateRemarksData = []
        for (let i = 0; i < maxLength; i++) {
            followUpDateRemarksData.push({
                date: selectedSellerPOItem.followUpRemarksTS[i] ? getDateString(selectedSellerPOItem.followUpRemarksTS[i]) : "Date not available",
                remark: selectedSellerPOItem.followUpRemarks[i] || "Remark not available"
            })
        }
        setFollowUpDateAndRemarks(followUpDateRemarksData)
    }, [selectedSellerPOItem])

    return (
        <div className="ml-2 mr-2 mt-0 pt-0">
            <div>
                <div className="flex justify-content-between">
                    <div className="flex flex-wrap py-2 w-full">
                        <div className="flex justify-content-between flex-grow-1 font-bold text-sm header-style" style={{ borderBottom: '1px solid rgb(217 227 222)' }}>
                            <div className="mt-1" style={{ width: '15%' }}>DATE</div>
                            <div className="mt-1" style={{ width: '90%', whiteSpace: 'pre-wrap' }}>REMARKS</div>
                        </div>
                        {
                            followUpDateAndRemarks.map((eachRemark, index) => {
                                return (
                                    <div className="flex justify-content-between flex-grow-1  w-full data-style" style={{ borderBottom: '1px solid rgb(217 227 222)', fontSize: "13px" }}>
                                        <div className="py-1 align-self-center" style={{ width: '15%', fontSize: "13px" }}>{eachRemark.date}</div>
                                        <div className="py-1 align-self-center" style={{ width: '90%', fontSize: "13px" }}>{eachRemark.remark}</div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}
export default FollowUpRemarksHistory;